if (!customElements.get('full-width-element')) {
  customElements.define('full-width-element', class FullWidthElement extends HTMLElement {
    /*
     * Setup runs in connectedCallback, not the constructor.
     *
     * For a parser-created element the constructor fires on the start tag,
     * before its attributes are applied, so `this.id` was still '' whenever the
     * async script happened to load ahead of the markup. That made
     * `document.getElementById('')` return null and ResizeObserver.observe()
     * throw "parameter 1 is not of type 'Element'" - intermittent, because it
     * depended on script/parser ordering. The observer now watches `this`, so
     * the id is not needed at all.
     */
    connectedCallback() {
      this.setScrollbarWidth();

      if (this.resizeObserver) return;
      this.resizeObserver = new ResizeObserver(() => this.setScrollbarWidth());
      this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
      if (!this.resizeObserver) return;
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }

    setScrollbarWidth() {
      const scrollbarWidth = window.innerWidth - document.body.clientWidth;

      document.body.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
    }
  });
}
